import React from 'react';

export default function Login({ onLogin }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background-light dark:bg-background-dark p-4">
      <div className="w-full max-w-md">
        <div className="bg-surface-light dark:bg-surface-dark p-8 rounded-xl shadow-lg border border-border-light dark:border-border-dark text-center">
          <div className="flex justify-center mb-6">
            <img
              src="http://digitalad.cz/wp-content/uploads/2017/07/digitalad_logo-768x138.png"
              alt="DigitalAd"
              className="h-12 w-auto"
            />
          </div>

          <h2 className="text-2xl font-bold text-text-light dark:text-text-dark mb-2">
            GA Analytics Chat
          </h2>

          <p className="text-muted-light dark:text-muted-dark mb-8">
            Dotazujte se na vaše GA4 data v češtině
          </p>

          <button
            onClick={onLogin}
            className="w-full bg-white dark:bg-surface-dark text-text-light dark:text-text-dark border border-border-light dark:border-border-dark py-3 px-6 rounded-lg font-medium hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors flex items-center justify-center gap-3 shadow-sm"
          >
            <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fillRule="evenodd">
                <path d="M17.6 9.2l-.1-1.8H9v3.4h4.8C13.6 12 13 13 12 13.6v2.2h3a8.8 8.8 0 0 0 2.6-6.6z" fill="#4285F4"/>
                <path d="M9 18c2.4 0 4.5-.8 6-2.2l-3-2.2a5.4 5.4 0 0 1-8-2.9H1V13a9 9 0 0 0 8 5z" fill="#34A853"/>
                <path d="M4 10.7a5.4 5.4 0 0 1 0-3.4V5H1a9 9 0 0 0 0 8l3-2.3z" fill="#FBBC05"/>
                <path d="M9 3.6c1.3 0 2.5.4 3.4 1.3L15 2.3A9 9 0 0 0 1 5l3 2.4a5.4 5.4 0 0 1 5-3.7z" fill="#EA4335"/>
              </g>
            </svg>
            Přihlásit přes Google
          </button>
        </div>
      </div>
    </div>
  );
}
